import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Select from 'react-select';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import CancellationPolicyService from '../../api/services/CancellationPolicyService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditPackagesItems = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [packages, setPackage] = useState([]);
  const [packageslist, setPackagelist] = useState([]);
  const [packageModal, setPackageModal] = useState(false);
  const [isLoading, setisloading] = useState(true);
  const [fetchvehicleData, setFetchvehicleData] = useState();
  useEffect(() => {
    var id = params.id;
    getPackageByID(id);
  }, []);

  const getPackageByID = async (id) => {
    try {
      let packages = await CancellationPolicyService.can_show(id).json();
      setPackage(packages.data);
      let packageslist = await CancellationPolicyService.index().json();

      setPackagelist(packageslist.data)
      let selecthome = packageslist.data.filter(function (item) {
        return item.id === packages.data.cancellation_policy_id
      });
      console.log(selecthome[0].id)
      setFetchvehicleData(selecthome);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const handlevehicle = (vehicle) => {
    setFetchvehicleData(vehicle)
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    console.log(fetchvehicleData.id)
    try {
      var userData = {
        "cancellation_policy_id": fetchvehicleData.id ? fetchvehicleData.id : fetchvehicleData[0].id,
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
      }

      let responseData = await CancellationPolicyService.can_update(params.id, userData).json()
      if (responseData.status === true) {
        setPackageModal(true)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Edit Cancellation Policy Item" pageTitle={'Edit Cancellation Policy Item'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Cancellation Policy Item</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          packages.title
                            ? packages.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" defaultValue={
                        packages.de_title
                          ? packages.de_title
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Cancellation Policy<span className="text-danger"></span></label>
                      <Select
                        name="package_id"
                        options={packageslist}
                        onChange={handlevehicle}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                            ? option.title
                            : option.title
                        }
                        value={fetchvehicleData}

                      />
                    </div>

                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1" >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={packageModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setPackageModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Cancellation Policy Item Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/cancellation-policy-items'} variant="danger light" onClick={() => setPackageModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditPackagesItems;